module.exports = __webpack_public_path__ + "static/media/uber.6e00ebb7.png";